export default
{
    name: 'terms',

    mounted()
    {
        requestAnimationFrame(() => this.$el.classList.remove('is-page-before'))
    },

    methods:
    {
        manageCookies()
        {
            window.Metomic.raise()
        }
    }
}
